

import { validateAmount } from '../validate/postDataValidators';


export const hasPostData = () => !!window.BOOTSTRAP_DATA.postData;


export const getRecipientName = () => {
    if (hasPostData()) {
        const { recipientName } = window.BOOTSTRAP_DATA.postData;
        return (typeof recipientName === 'string' ? recipientName : null);
    }
    return null;
};

export const getSenderName = () => {
    if (hasPostData()) {
        const { senderName } = window.BOOTSTRAP_DATA.postData;
        return (typeof senderName === 'string' ? senderName : null);
    }
    return null;
};

export const getAmount = () => {
    if (hasPostData()) {
        const { amount } = window.BOOTSTRAP_DATA.postData;
        return validateAmount(amount);
    }
    return 0;
};

export const getRecipientEmail = () => {
    if (hasPostData()) {
        const { recipientEmail } = window.BOOTSTRAP_DATA.postData;
        return (typeof recipientEmail === 'string' ? recipientEmail : null);
    }
    return null;
};

export const getCardType = () => {
    if (hasPostData()) {
        const { cardType } = window.BOOTSTRAP_DATA.postData;
        return ((cardType === 'digital' || cardType === 'physical') ? cardType : null);
    }
    return null;
};

export const getFaceplateCode = () => {
    if (hasPostData()) {
        const { faceplateCode } = window.BOOTSTRAP_DATA.postData;
        return (typeof faceplateCode === 'string' ? faceplateCode : null);
    }
    return null;
};
